/**
 * openStudyDoc — shared citation-chip click target for the protocol/ICF AI
 * wizard. Fetches a presigned URL for a study document and opens it in a new
 * tab. Extracted so the in-call CallWorkspace and the profile
 * StudyReferenceDrawer share one implementation instead of two copies.
 *
 * The id may belong to either store: legacy crm.study_documents, or (for a
 * registry-linked study, plan §5.1) an eReg registry document — the AI
 * wizard's citations carry whichever fed the answer. Legacy resolves first;
 * a 404 falls through to the CRM registry proxy.
 */
import api from '../../../services/api';

export async function openStudyDoc(documentId: string): Promise<void> {
  let url: string | undefined;
  try {
    const res = await api.get(`/api/crm/study-documents/${documentId}/url`);
    url = res.data?.url;
  } catch (err: any) {
    // 404 = not a legacy doc; 503 = legacy storage unconfigured — either way
    // the registry proxy may still serve it.
    const status = err?.response?.status;
    if (status !== 404 && status !== 503) throw err;
    const res = await api.get(`/api/crm/registry/documents/${documentId}/file`);
    url = res.data?.url;
  }
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
}
